import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";
import Text from "../ui/Text";

export default class UnlockScene extends Scene {
    constructor(charData)
    {
        super('UnlockScene');

        this.charData = charData;

        this.spine = null;
    }

    init()
    {
        super.init('bg');

        var spineData = P3.assets.spineData(this.charData.spine + '_big');
        this.spine = new PIXI.spine.Spine(spineData);
        this.spine.scale.set(-0.7, 0.7);

        this.spine.skeleton.setSlotsToSetupPose();
        this.spine.skeleton.setToSetupPose();
        this.spine.autoUpdate = false;

        if(this.charData.skin)
        {
            this.spine.skeleton.setSkin(this.spine.spineData.findSkin(this.charData.skin));
        }

        this.spine.x = common.STAGE_HALF_WIDTH;
        this.spine.y = common.STAGE_HEIGHT - 80;

        this.addChild(this.spine);

        this.spine.stateData.setMix('char_enter_arena', 'char_idle_menu', 0.2);
        
        this.spine.visible = false;
        P3.utils.delay(1, () => 
        {
            this.spine.state.setAnimation(0, 'char_enter_arena', false);
            this.spine.visible = true;
        });

        this.spine.state.addListener(
            {
                complete: function(entry)
                { 
                    var anim = entry.animation.name;
                    if(anim === 'char_enter_arena')
                    {
                        this.spine.state.setAnimation(0, 'char_idle_menu', true);
                    }
                    
                }.bind(this)
            });

        var titleText = new Text(common.text.translate('nowYouCanPlayAs'), {
            font: 55 + "px Lalezar48",
            align: "center"/*,
            tint: 0x000000*/
        });
        titleText.x = common.STAGE_HALF_WIDTH;
        titleText.y = 70;
        titleText.anchor.set(0.5);
        this.addChild(titleText);

        var charText = new Text(common.text.translate(this.charData.name), {
            font: 70 + "px Lalezar56",
            align: "center"/*,
            tint: 0x000000*/
        });
        charText.x = common.STAGE_HALF_WIDTH;
        charText.y = titleText.y + titleText.height + 15;
        charText.anchor.set(0.5);
        this.addChild(charText);

        common.text.translate(this.charData.name)

        this.buttons.play = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_large_out'),
            P3.assets.texture('btn_primary_large_over'),
            P3.assets.texture('btn_primary_large_down'),
            P3.assets.texture('icon_play')
        ));
        this.buttons.play.id = 'play';
        this.buttons.play.icon.anchor.set(0.45, 0.53);
        this.buttons.play.x = common.STAGE_HALF_WIDTH + 100;
        this.buttons.play.y = common.STAGE_HEIGHT - 130;
        this.signalListeners.push(this.buttons.play.signals.click.add(this.onButtonClicked, this));
        this.addChild(this.buttons.play);
        
        if(common.currentBout < common.config.settings.gameFlow.enemyOrder.length)
        {
            this.buttons.charSelect = new Button(new P3.ButtonStates(
                P3.assets.texture('secondary_large_character_select_out'),
                P3.assets.texture('secondary_large_character_select_over'),
                P3.assets.texture('secondary_large_character_select_down'),
                P3.assets.texture('character_select_icon')
            ));
            this.buttons.charSelect.id = 'charSelect';
            this.buttons.charSelect.x = common.STAGE_HALF_WIDTH - 100;
            this.buttons.charSelect.y = common.STAGE_HEIGHT - 130;
            this.signalListeners.push(this.buttons.charSelect.signals.click.add(this.onButtonClicked, this));
            this.addChild(this.buttons.charSelect);
        }
        else
        {
            this.buttons.play.x = common.STAGE_HALF_WIDTH;
        }
    }

    destroy()
    {
        super.destroy();
    }

    update()
    {
        super.update();

        this.spine.update(P3.Ticker.dt * common.timeStretch);
    }

    resize()
    {
        super.resize();
    }

    onButtonClicked(button)
    {
        this.signals.next.dispatch(button.id);
    }
}